module.exports = __webpack_public_path__ + "media/images/icons/flags/GR-27284662da31b903a723f802ea7efd72.svg";